import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableContainer: {
            display: 'table-cell',
            width: '50%',
            border: '1px solid',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                display: 'block'
            },
            [theme.breakpoints.down('xs')]: {
                width: '100%',
            }
        },
        body: {
            padding: '1.5vh 2vh',
        },
        marginContent: {
            margin: '6vh 0'
        },
        head: {
            width: '100%',
            padding: "1vh 0",
            textAlign: 'center',
            borderBottom: '1px solid',
            background: '#e8eef4',
            fontSize: '2.75vh',
        },
    })
);

export default useStyles;